import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Deleted")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_descriptions, {
      column: 1,
      direction: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, {
          label: "Date Created:",
          span: ""
        }, {
          default: _withCtx(() => [
            _createVNode("strong", null, _toDisplayString(new Date(_ctx.item.dateCreated).toLocaleString()), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Status:" }, {
          default: _withCtx(() => [
            (_ctx.item.dateDeleted)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  size: "medium",
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.item.status === 'Issued')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        size: "medium",
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.item.status), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        size: "medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.item.status), 1)
                        ]),
                        _: 1
                      }))
                ], 64))
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Total price:" }, {
          default: _withCtx(() => [
            _createVNode("strong", null, "$ " + _toDisplayString(parseFloat(_ctx.item.total).toFixed(2)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "Date Expire:" }, {
          default: _withCtx(() => [
            _createVNode("strong", null, _toDisplayString(new Date(_ctx.item.expireDate).toLocaleString()), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _ctx.lineItems,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Name",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row?.connection?.name || scope.row.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "Price",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(parseFloat(scope.row.price).toFixed(2)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          prop: "discount",
          label: "Discount(%)"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(parseFloat(scope.row.discount || 0)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "platform.name",
          label: "Platform"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}